import { render, staticRenderFns } from "./RolPage.vue?vue&type=template&id=2064035e"
import script from "./RolPage.js?vue&type=script&lang=js&external"
export * from "./RolPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports